import { render } from "./video.vue?vue&type=template&id=6b2f31fc"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
script.render = render

export default script